// src/components/VideoModal.js
import React from "react";
import {Modal, ModalDialog, ModalClose, Box} from "@mui/joy";

export default function VideoModal({ open, onClose, videoUrl }) {
    return (
        <Modal open={open} onClose={onClose}>
            <ModalDialog
                layout="center"
                sx={{
                    p: 0,
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                }}
            >
                <ModalClose sx={{color: 'white', '&:hover': {backgroundColor: 'rgba(0,0,0,0.3)'}}} />
                <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                    <video key={videoUrl} style={{maxWidth: '90vw', maxHeight: '90vh', borderRadius: '8px'}} controls autoPlay muted>
                        <source src={videoUrl}/>
                        Your browser does not support the video tag.
                    </video>
                </Box>
            </ModalDialog>
        </Modal>
    );
}